export enum LoginResult {
    SUCCESS,
    REDIRECT
}
